import React, { Component } from 'react';
import './App.css';
import Home from '../Home/Home';
import SelectScope from '../SelectScope/SelectScope';
import Review from '../Review/Review';
import { toEnglishDigits } from '../../utils'

class App extends Component {

  constructor(props) {
    super(props)

    let self = this

    let defaultRange = localStorage.getItem('range')
    if (defaultRange) defaultRange = JSON.parse(defaultRange)
    else defaultRange = {start: 2348, end: 2482}

    this.state = {
      /**
       * @type {('home'|'select-scope'|'review')}
       */
      page: 'home',
      /**
       * @type {{current: number, start: number, end: number}}
       */
      reviewRange: {
        start: defaultRange.start,
        end: defaultRange.end,
        current: defaultRange.start
      },
    }

  }

  goToPage = (page) => {
    this.setState({page})
  }

  getPageNumber() {
    switch(this.state.page) {
      case 'home': return 0;
      case 'select-scope': return 1;
      case 'review': return 2;
      default: return NaN
    }
  }

  handleScopeSubmit = ({start, end}) => {
    if (start > end) [start, end] = [end, start]
    start = Math.min(6234, start)
    end = Math.min(6234, end)
    const current = Math.floor((end - start) * Math.random() + start)
    this.setState({reviewRange: {start, end, current}, page: 'review'})
    
    localStorage.setItem('range', JSON.stringify({start, end}))
  }

  render() {

    const transform = `translate3d(${this.getPageNumber()}00%, 0, 0)`

    return (
      <div className="pages__wrapper" style={{transform}}>
        <Home goToPage={this.goToPage} />
        <SelectScope
          goToPage={this.goToPage}
          reviewRange={this.state.reviewRange}
          // onChanged={this.handleScopeChange}
          onSubmit={this.handleScopeSubmit}
        />
        <Review page={this.state.page} goToPage={this.goToPage} reviewRange={this.state.reviewRange} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/App/App.jsx